import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
export function HowWeWork() {
  return <section className="w-full py-20 px-6 bg-white" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-70">How We Work</h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-71">
          Transparency and honesty are at the heart of everything we do at{' '}
          <a href="https://softwarepair.com/" rel="dofollow" className="text-blue-600 hover:text-blue-800 font-medium underline" data-id="element-72">
            softwarepair.com
          </a>
          . We believe our readers deserve complete clarity about how we operate
          and what drives our recommendations.
        </p>
        <div className="bg-blue-50 p-8 rounded-lg mb-8" data-id="element-73">
          <div className="flex items-start mb-6" data-id="element-74">
            <CheckCircleIcon className="w-6 h-6 text-blue-600 mr-3 mt-1 flex-shrink-0" data-id="element-75" />
            <p className="text-gray-700 leading-relaxed" data-id="element-76">
              <strong data-id="element-77">Rigorous Testing:</strong> When we recommend tools or
              software, it's because we've personally tested them and believe in
              their value. We don't recommend products we haven't thoroughly
              evaluated.
            </p>
          </div>
          <div className="flex items-start mb-6" data-id="element-78">
            <CheckCircleIcon className="w-6 h-6 text-blue-600 mr-3 mt-1 flex-shrink-0" data-id="element-79" />
            <p className="text-gray-700 leading-relaxed" data-id="element-80">
              <strong data-id="element-81">Honest Reviews:</strong> Our opinions are never for sale.
              While some of our content may include affiliate links — meaning we
              may earn a small commission if you make a purchase — this never
              influences our honest assessment of any product or service.
            </p>
          </div>
          <div className="flex items-start" data-id="element-82">
            <CheckCircleIcon className="w-6 h-6 text-blue-600 mr-3 mt-1 flex-shrink-0" data-id="element-83" />
            <p className="text-gray-700 leading-relaxed" data-id="element-84">
              <strong data-id="element-85">Quality First:</strong> Our focus remains on delivering
              quality insights, honest reviews, and expert-backed content that
              genuinely helps you make better digital decisions.
            </p>
          </div>
        </div>
        <p className="text-lg text-gray-700 leading-relaxed" data-id="element-86">
          We understand that choosing the right software or security solution
          can be overwhelming. That's why we break down complex features,
          compare alternatives side-by-side, and highlight both strengths and
          weaknesses. Our goal is to give you all the information you need to
          make a decision that's right for your specific situation.
        </p>
      </div>
    </section>;
}